import script from "./PageHeaderCta.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeaderCta.vue?vue&type=script&setup=true&lang=js"

import "./PageHeaderCta.vue?vue&type=style&index=0&id=5fd33fd2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd33fd2"]])

export default __exports__